<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone esquerda"><a @click="this.$router.back();" style="cursor: pointer;"
                    class="icone-voltar m-d"></a></div>
            <h2>Reuniões - Lista de Temas em Agenda</h2>
        </div>
    </div>
    <div class="margem container">
        <div class="bloco margem">
            <div class="direita">
                <v-btn icon="mdi-plus" class="acao-secundaria" @click="verTema('criar')"></v-btn>
            </div>
            <table class="tabela">
                <tbody>
                    <tr>
                        <th v-for="i, index in labels" :key="index">{{ i.label }}</th>
                        <th>Excluir</th>
                    </tr>
                    <tr v-for="tema, index in temas" :key="index" @click="verTema(tema.id)">
                        <template v-for="l in labels" :key="l.id">
                            <td v-if="l.chave == 'dataFim'">{{ formatarData(tema[l.chave]) }}</td>
                            <td v-else>
                                {{ tema[l.chave] }}
                            </td>
                        </template>
                        <td @click.stop><i @click="excluirTema(tema.id)" class="bi-trash"></i></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import service from '@/services/serviceReuniões'
export default {
    data() {
        return {
            temas: [],
            labels: [],
            modalTemaTemporario: false,
            temaSelecionado: {},
        }
    },
    created() {
        this.getTemas()
    },
    methods: {
        async getTemas() {
            const response = await service.getTemas()
            this.temas = response.data;
            this.labels = response.labels;
        },
        formatarData(data) {
            const partes = data.split('-')
            return `${partes[2]}/${partes[1]}/${partes[0]}`
        },
        verTema(id) {
            this.$router.push({ name: 'viewTemasTemporario', params: { id: id } })
        },
        async excluirTema(id) {
            const confirmacao = confirm('Deseja realmente excluir este tema?')
            if (confirmacao) {
                await service.excluirTema(id);
                this.getTemas()
            }

        }
    },
}
</script>

<style scoped>
i {
    color: var(--cor-erro);
    font-size: 16px;
    transition: all 200ms ease-in;
}

i:hover {
    cursor: pointer;
    transform: scale(1.1);
}
</style>